import ReactGA from 'react-ga';
import DataManager from "./DataManagers/DataManager";

const GOOGLE_ANALYTICS_TRACKING_ID = 'UA-147225805-1'

// Constants

// const CATEGORIES = {
// 	navigation: 'navigation',
// }
//
// const ACTIONS = {
// 	advanceSlide: 'advanceSlide',
// }
//
// export const GOOGLE_ANALYTICS_EVENTS = {
// 	advanceSlide: {
// 		category: CATEGORIES.navigation,
// 		action: ACTIONS.advanceSlide,
// 	}
// }

// Helper functions

export const initializeReactGA = () => {
	ReactGA.initialize(GOOGLE_ANALYTICS_TRACKING_ID);
}

export const recordSceneChangeAsPageviewInGA = (newIndex, showStartScreen) => {
	const newScene = DataManager.getStorySceneAtIndex(newIndex)
	const gaObjectPageview = {
		hitType: 'pageview',
		page: showStartScreen ? `/startScreen` : `/slide${newIndex + 1}`, // must start with /, default is location.pathname
		title: showStartScreen ? 'Start Screen' : newScene.title,
	}
	
	const ga = ReactGA.ga()
	ga('send', gaObjectPageview)
}
